import { api } from './client';
import type { PortalReport } from '@affogato/shared';

interface PortalReportResponse {
  report: PortalReport;
}

interface PortalReportsListResponse {
  reports: PortalReport[];
}

interface GenerateReportRequest {
  instructions?: string;
  locale?: string;
}

interface UpdateReportRequest {
  title?: string;
  content?: string;
}

export const portalReportsApi = {
  /**
   * Generate a documentation status report with AI
   */
  generate: (clientId: string, data: GenerateReportRequest = {}) =>
    api.post<PortalReportResponse>(`/portal-reports/${clientId}/generate`, data),

  /**
   * List all reports for a client's portal
   */
  list: (clientId: string) =>
    api.get<PortalReportsListResponse>(`/portal-reports/${clientId}`),

  /**
   * Get a specific report
   */
  get: (clientId: string, reportId: string) =>
    api.get<PortalReportResponse>(`/portal-reports/${clientId}/${reportId}`),

  /**
   * Update a report (title and/or content)
   */
  update: (clientId: string, reportId: string, data: UpdateReportRequest) =>
    api.patch<PortalReportResponse>(`/portal-reports/${clientId}/${reportId}`, data),

  /**
   * Publish a report
   */
  publish: (clientId: string, reportId: string) =>
    api.post<PortalReportResponse>(`/portal-reports/${clientId}/${reportId}/publish`),

  /**
   * Delete a report
   */
  delete: (clientId: string, reportId: string) =>
    api.delete<{ success: boolean }>(`/portal-reports/${clientId}/${reportId}`),
};
